import MultiSelect from 'components/MultiSelect';
import useAgronomistList, {
  type Config as AgronomistListConfig,
} from 'hooks/useAgronomistList';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

interface AgronomistFilterProps
  extends Omit<ComponentProps<typeof MultiSelect>, 'options' | 'label'> {
  country: string;
  options?: AgronomistListConfig;
  label?: string;
}
const AgronomistFilter = ({
  country,
  value,
  onChange,
  disabled,
  options,
  ...props
}: AgronomistFilterProps) => {
  const { agronomistFilterOptions, isLoading: isAgronomistLoading } =
    useAgronomistList(country, options);
  const { t } = useTranslation();

  return (
    <MultiSelect
      label={t('common.filters.agronomist')}
      options={agronomistFilterOptions}
      defaultValue={value}
      value={value}
      onChange={onChange}
      disabled={disabled || isAgronomistLoading}
      allowClear
      {...props}
    />
  );
};

export default AgronomistFilter;
